/**
 * O `Topbar` do painel com os itens de experiência no menu da conta: layout (I3), busca
 * (I1), novidades com ponto (I5), sugestão (I4), atalhos e "mostrar dicas de novo" (I2).
 * As ações que o layout já passa (Configurações, Sair) continuam por último.
 */
import { Keyboard, Lightbulb, MessageSquarePlus, Search, Sparkles } from 'lucide-react';
import { DensityToggle, Topbar } from '@mgdlead/ui';
import type { TopbarProps, UserMenuAction } from '@mgdlead/ui';

import { useExperience } from './ExperienceProvider';
import { isApplePlatform, isCoarsePointer, searchShortcutLabel } from './platform';

export function ExperienceTopbar({ userActions = [], ...props }: TopbarProps) {
  const { density, setDensity, hasNews, openDialog, resetHints } = useExperience();

  const toque = isCoarsePointer();
  const atalho = searchShortcutLabel(isApplePlatform(), toque);

  const extra: UserMenuAction[] = [
    {
      id: 'buscar',
      label: atalho ? `Buscar (${atalho})` : 'Buscar',
      icon: <Search />,
      onSelect: () => openDialog('palette'),
    },
    {
      id: 'novidades',
      label: 'Novidades',
      icon: <Sparkles />,
      badge: hasNews,
      onSelect: () => openDialog('news'),
    },
    {
      id: 'sugestao',
      label: 'Enviar sugestão',
      icon: <MessageSquarePlus />,
      onSelect: () => openDialog('feedback'),
    },
    // No celular não há teclado físico: o item não serve e some.
    ...(toque
      ? []
      : [
          {
            id: 'atalhos',
            label: 'Atalhos do teclado',
            icon: <Keyboard />,
            onSelect: () => openDialog('shortcuts'),
          },
        ]),
    { id: 'dicas', label: 'Mostrar as dicas de novo', icon: <Lightbulb />, onSelect: resetHints },
  ];

  return (
    <Topbar
      {...props}
      userActions={[...extra, ...userActions]}
      userMenuContent={<DensityToggle value={density} onChange={setDensity} />}
    />
  );
}
